import { Alert, AlertTitle, Link, Paragraph, Stack, Text } from '@sixfold/common-ui';
import React from 'react';

export const COMPANY_GROUP_DOCS_URL =
  'https://app.notion.com/p/trimble-tl/Company-Groups-account-linking-feature-overview-enablement-3f0c1b3dd256811b8b55c8d0a07db628';

export const CompanyGroupDocsLink: React.FC = () => (
  <Link href={COMPANY_GROUP_DOCS_URL} target="_blank" rel="noopener noreferrer">
    Company Groups feature overview
  </Link>
);

export const CompanyGroupExplainer: React.FC = () => (
  <Alert kind="info">
    <AlertTitle>What is a company group?</AlertTitle>
    <Stack direction="column" gap="xsmall">
      <Paragraph>
        A company group links related Visibility accounts (for example branches of one carrier) so they share one
        network of carriers and subcontractors.{' '}
        <Text weight="bold">One account is the hub, and the others link directly to it.</Text> An account can belong to
        only one group.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">Stays per account:</Text> relation identifiers, pending invites, own customers, vehicles,
        integrations, users and archiving.
      </Paragraph>
      <Paragraph>
        Membership does not grant tour visibility or vehicle access.{' '}
        <Text weight="bold">Partners added by the group get the standard data-sharing consent.</Text> Deleting a partner
        relationship in Backoffice removes it from every account in the group.
      </Paragraph>
      <Paragraph>
        Read more: <CompanyGroupDocsLink />
      </Paragraph>
    </Stack>
  </Alert>
);
